angular.module('bmsApp.trugreen.visitplanner').controller('TGVisitPlannerCtrl',
	function ($state,
			  $scope,
			  VisitPlannerSvc,
			  $timeout,
			  $filter,
			  $mdDialog,
			  EmployeeSvc,
			  TGRouteSvc,
			  TGJobSvc,
			  $ngBootbox,
			  notify,
			  $q) {


		function init() {
			VisitPlannerSvc.index($state.params.quoteId).then(function (response) {
				self.quote = response.data.tg_job;
				duplicateMultipleTreatments();
				updateAllVisitFooters();
				if (self.quote.visits.length === 0) {
					addVisit(); // add stub visit if none exist
				}
				else {
					// expand the first visit
					self.quote.visits[0].expand = true;
				}

				self.loading = false;
			});

			for (i = 1; i < 13; i++) {
				var weekLabel = (i == 1) ? ' week' : ' weeks';
				self.intervals.push({
					id: i,
					label: 'Add ' + i + weekLabel
				});
			}
		}

		function cancel() {
			if ($state.params.return === 'edit-quote') {
				$state.go('main.trugreen.quote.index.view.update', {quoteId: $state.params.quoteId});
			}
			else if ($state.params.return === 'convert-quote') {
				$state.go('main.trugreen.quote.index.view.convert', {quoteId: $state.params.quoteId});
			}
			else {
				$state.go('main.trugreen.quote.index.view', {quoteId: $state.params.quoteId});
			}
		}

		function copyPlanFromSourceJob() {
			$ngBootbox.confirm('Are you sure you want to copy visit plan for this job from it\'s source job?')
				.then(function () {
					// get source job visits and replicate here
						TGJobSvc.read(self.quote.duplicate_id, {page_name: 'view'}).then(function (result) {
							self.quote.visits = [];

							// add all visits from source job to current job
							angular.forEach(result.data.tg_job.visits, function (sourceVisit) {
								addVisit();
								var visit = self.quote.visits[self.quote.visits.length - 1];
								// add all treatments from source visit to job visit
								angular.forEach(sourceVisit.treatments, function (sourceTreatment) {
									var treatment = $filter('filter')(self.quote.treatments, {
										'duplicate_id': sourceTreatment.treatment_id,
										'added_to_visit': false,
									});
									if(treatment.length > 0){
										treatment = treatment[0];
										treatment = dropTreatmentToVisitCallback(null, null, treatment, null, null, null)
										dropInserted(null, null, treatment, null, null, visit, true);
										visit.treatments.push(treatment);
									}
								});
							});
						}, function (errors) {
							self.errors = errors;
						});
					}
				);
		}

		// Treatments with multiple treatments_per_year are duplicated back onto the array
		function duplicateMultipleTreatments() {
			let allocatedTreatments = [];
			angular.forEach(self.quote.visits, function(visit)  {
				angular.forEach(visit.treatments, function(treatment) {
					allocatedTreatments.push(treatment);
				});
			});

			angular.forEach(self.quote.treatments, function (jobTreatment) {
				if (jobTreatment.treatments_per_year > 1) {
					let allocated = $filter('filter')(allocatedTreatments, {treatment_id: jobTreatment.id}, true);
					let treatmentsCount = jobTreatment.treatments_per_year - allocated.length;
					// jobTreatment.treatment_used = treatmentsCount || 0;
					for (i = 1; i < treatmentsCount; i++) {
						self.quote.treatments.push(angular.copy(jobTreatment));
					}
				}
			});
		}

		function addVisit() {
			self.quote.visits.push({
				treatments: [],
				expand: true,
				job: {
					site: angular.copy(self.quote.site)
				}
			});
		}

		function dropTreatmentToVisitCallback(event, index, treatment, external, type, visit) {
			// Copy the item attributes into the same structure as the visit_treatment
			angular.extend(treatment, {
				treatment: {
					treatment_attr: angular.copy(treatment.treatment_attr),
					products: angular.copy(treatment.products),
					details: angular.copy(treatment.details),
					tg_quote_and_job_id: treatment.tg_quote_and_job_id,
					id: treatment.id,
				}
			});

			return treatment;
		}

		function dropTreatmentFromVisitCallback(event, index, treatment, external, type, visit) {
			console.log(treatment);
			if (angular.isObject(treatment.treatment)) {
				return treatment.treatment;
			}
			else {
				return treatment;
			}
		}

		function dragStarted(event, index, treatment, external, type, visit) {
			if (!visit.selected) {
				setSelectedVisit(index, visit);
			}
		}

		function dropInserted(event, index, treatment, external, type, visit, droppedToVisit) {

			if (!droppedToVisit) {
				if (treatment.hasOwnProperty('visit_id')) {
					treatment.treatment.added_to_visit = false;
				}
				else {
					treatment.added_to_visit = false;
				}
			}
			else {
				treatment.added_to_visit = true;
			}



			if (angular.isObject(visit)) {
				updateVisitFooter(visit);
			}
			else {
				updateAllVisitFooters();
			}

			if (angular.isDefined(visit)) {
				if (!visit.selected) {
					setSelectedVisit(index, visit);
				}
			}
		}

		function updateTreatmentTime(ev, treatment, visit) {
			var confirm = $mdDialog.prompt()
				.title('Update Treatment Time (in minutes)')
				.textContent(treatment.treatment_attr.name)
				.ariaLabel('Update treatment time (in minutes)')
				.initialValue(treatment.details.treatment_time_in_mins)
				.targetEvent(ev)
				.ok('Update')
				.cancel('Cancel');

			$mdDialog.show(confirm).then(function (result) {
				angular.extend(treatment, {
					details: {treatment_time_in_mins: result}
				});

				if (angular.isObject(visit)) {
					updateVisitFooter(visit)
				}
			});

		}

		function updateAllVisitFooters() {
			angular.forEach(self.quote.visits, function (visit) {
				updateVisitFooter(visit);
			});
		}

		function updateVisitFooter(visit) {
			var totalMinutes = 0;
			var totalTreatments = 0;

			$timeout(function () {
				angular.forEach(visit.treatments, function (treatment) {
					totalMinutes += (angular.isObject(treatment.treatment)) ? parseFloat(treatment.treatment.details.treatment_time_in_mins) : parseFloat(treatment.details.treatment_time_in_mins);
					totalTreatments++;
				});
				angular.extend(visit, {
					total_minutes: totalMinutes,
					visit_minutes: totalMinutes,
					total_treatments: totalTreatments
				});

				if (angular.isObject(visit.route)) {
					angular.extend(visit.route, {
						total_work_time: totalMinutes
					});
				}
				else {
					// create a new route
					angular.extend(visit, {
						route: {
							date: visit.visit_date,
							total_work_time: totalMinutes,
							employee_id: null
						}
					});
				}

				// Also update this figure on the route
				if (angular.isObject(visit.saved_route)) {
					angular.forEach(visit.saved_route.routes, function (route) {
						angular.forEach(route.visits, function (visitObject) {
							if (visitObject.visit_date == visit.visit_date && visitObject.job.site.id == visit.job.site.id) {
								visitObject.visit_minutes = totalMinutes;
							}
						});
					});
					angular.extend(self, {
						routes: visit.saved_route.routes
					});
				}
				else {
					// loop through all self.routes and update
					if (visit.selected) {
						console.log('update self.routes');
					}
				}

				// update the total work time
				angular.forEach(self.routes, function (route) {
					var totalWorkTime = 0;
					angular.forEach(route.visits, function (visit) {
						totalWorkTime += parseFloat(visit.visit_minutes);
					});
					route.total_work_time = totalWorkTime;
				});

				if (self.summaryView == 'all-visits') {
					getVisitSummary();
				}

			}, 10);
		}

		function removeVisit(index, visit) {

			if (visit.selected) {
				visit.selected = true;
				setSelectedVisit(index, visit);
			}
			angular.forEach(visit.treatments, function (treatment, idx) {
				if (treatment.hasOwnProperty('visit_id')) {
					treatment.treatment.added_to_visit = false;
				}
				else {
					treatment.added_to_visit = false;
				}


				if (angular.isObject(treatment.treatment)) {
					self.quote.treatments.push(treatment.treatment);
				}
				else {
					self.quote.treatments.push(treatment);
				}
			});


			self.quote.visits.splice(index, 1);
		}

		function updateVisitDates(index, visit) {
			if (index > 0) {
				if (angular.isDefined(self.quote.visits[index - 1].visit_date)) {
					var lastVisitDate = moment(self.quote.visits[index - 1].visit_date);
					visit.visit_date = lastVisitDate.add(visit.week_interval.id, 'week');
				}

				// update subsequent visit dates after this if the week interval is set
				for (var i = index + 1; i < self.quote.visits.length; i++) {
					var visitAtIndex = self.quote.visits[i];
					if (angular.isDefined(self.quote.visits[index - 1].visit_date)) {
						var lastVisitDate = moment(self.quote.visits[i - 1].visit_date);
						if (angular.isObject(visitAtIndex.week_interval)) {
							visitAtIndex.visit_date = lastVisitDate.add(visitAtIndex.week_interval.id, 'week');
						}
					}
				}
			}
			if (!visit.selected) {
				setSelectedVisit(index, visit);
			}
		}

		function visitDateUpdated(index, visit) {
			// Check we don't already have the same visit date in our array, that would be bad
			var dateInUse = 0;
			angular.forEach(self.quote.visits, function (visitObject) {
				if (visit.visit_date == visitObject.visit_date) {
					dateInUse++;
				}
			});
			if (dateInUse > 1) {
				visit.visit_date = null;
				notify({
					message: 'You cannot select this visit date more than once',
					classes: 'error'
				});
			}
			else {
				visit.employee = null; //reset

				setSelectedVisit(index, visit, true);

			}
		}

		function unusedTreatmentCount() {
			var unusedCount = 0;
			if (angular.isObject(self.quote)) {
				angular.forEach(self.quote.treatments, function (treatment) {
					if (!treatment.added_to_visit) {
						unusedCount++;
					}
				});
			}
			return unusedCount;
		}

		function setSelectedVisit(index, visit, forceSelection) {

			angular.forEach(self.quote.visits, function (visit, idx) {
				if (index !== idx) { // only deselect ones that aren't the current one so we can toggle
					visit.selected = false;
				}
			});

			visit.selected = !visit.selected;

			if (forceSelection) {
				visit.selected = true;
			}

			self.summaryView = (visit.selected) ? 'visit' : 'all-visits';
			if (visit.selected) {
				self.selectedVisit = visit;
				if (angular.isDefined(visit.visit_date)) {
					if (angular.isObject(visit.saved_route) && visit.visit_date == visit.saved_route.date) {
						self.routes = visit.saved_route.routes;
						self.employees = visit.saved_route.employees;
					}
					else {
						getRouteForVisit(visit);
					}
				}
				else {
					self.routes = null;
				}

				getWorkInArea(visit);
			}
			else {
				self.selectedVisit = null;
				getVisitSummary();
			}

		}


		function getVisitSummary() {
			var visitDates = [];
			angular.forEach(self.quote.visits, function (visit) {
				if (angular.isDefined(visit.visit_date)) {
					visitDates.push(visit.visit_date);
				}
			});
			var routeParams = {
				filter: {
					inDates: visitDates
				},
				sorting: {
					date: 'asc'
				}
			};
			if (visitDates.length > 0) {
				TGRouteSvc.index(routeParams).then(function (response) {
					self.routeSummary = response.data.route_collection;

					// Check if we have a route for each visit in our quote, if we don't, add one.
					for (var i = 0; i < self.quote.visits.length; i++) {
						var found = false;
						angular.forEach(self.routeSummary, function (route) {
							if (self.quote.visits[i].visit_date == route.date) {
								found = true;
							}
						});

						if (!found) {
							self.routeSummary.push({
								date: self.quote.visits[i].visit_date,
								visits: []
							});
						}
					}

					angular.forEach(self.quote.visits, function (visit) {
						angular.forEach(self.routeSummary, function (route) {
							if (visit.visit_date == route.date) {
								angular.forEach(route.visits, function (routeVisit) {
									if (routeVisit.job.site.id === visit.job.site.id) {
										route.visits.splice(route.visits.indexOf(visit), 1);
									}
								});
								route.visits.push(angular.copy(visit));
							}
						});
					});

					// update totals
					angular.forEach(self.routeSummary, function (route) {
						var totalMinutes = 0;
						angular.forEach(route.visits, function (visit) {
							totalMinutes += parseFloat(visit.visit_minutes);
						});
						route.total_work_time = totalMinutes;
					})

				});
			}
		}

		function getRouteForVisit(visit) {
			self.loadingRoute = true;
			var employeeParams = {
				filter: {
					availableOnDate: visit.visit_date,
					status: true
				}
			};
			var routeParams = {
				filter: {
					date: visit.visit_date
				}
			};
			var promises = {
				employees: EmployeeSvc.index(employeeParams),
				routes: TGRouteSvc.index(routeParams)
			};

			$q.all(promises).then(function (responses) {
				self.employees = responses.employees.data.employee_collection;
				self.routes = responses.routes.data.route_collection;

				// // copy this route to the visit so we don't have to retrieve it later
				//
				angular.extend(visit, {
					saved_route: {
						routes: angular.copy(self.routes),
						date: visit.visit_date,
						employees: self.employees
					}
				});



				if (!self.selectedVisit.employee) {
					if (self.quote.preferred_employee) {
						self.selectedVisit.employee = self.quote.preferred_employee;
						technicianUpdated();
					}
					else if (self.employees.length === 1) {
						console.log('auto populated');
						self.selectedVisit.employee = self.employees[0];
						technicianUpdated();
					}
				}


				updateVisitFooter(visit);
				self.loadingRoute = false;

			});
		}

		function technicianUpdated() {
			// Add the visit to the route if it's not already on there
			$timeout(function () {
				if (angular.isObject(self.selectedVisit.employee)) {
					self.selectedVisit.employee_id = self.selectedVisit.employee.id;
				}
				else {
					self.selectedVisit.employee_id = null;
				}


				var existingRoute;

				angular.forEach(self.routes, function(route) {
					if (route.employee_id === self.selectedVisit.employee_id && self.selectedVisit.visit_date === route.date) {
						existingRoute = angular.copy(route);
					}
				});

				if (!angular.isObject(existingRoute)) {
					existingRoute = {
						date: self.selectedVisit.visit_date
					};
				}

				angular.extend(existingRoute, {
					employee_id: self.selectedVisit.employee_id
				});

				angular.extend(self.selectedVisit, {
					route: existingRoute,
				});


				// Find the corresponding route in the quote.visits collection and update the employee id (or create a new route)
				// angular.forEach(self.quote.visits, function (v) {
				// 	if (v.job.site.id === self.selectedVisit.job.site.id && v.visit_date === self.selectedVisit.visit_date) {
				// 		if (angular.isObject(v.route)) {
				// 			v.route.employee_id = self.selectedVisit.employee.id;
				// 			v.route.date = v.visit_date;
				// 		}
				// 		else {
				// 			console.log('creating new route');
				// 			// create new route
				// 			angular.extend(v, {
				// 				route: {
				// 					date: v.visit_date,
				// 					employee_id: self.selectedVisit.employee.id
				// 				}
				// 			});
				//
				// 		}
				// 	}
				// });

				// sync
				existingRoute = false;
				angular.forEach(self.routes, function (route, index) {

					route.visits = _.reject(route.visits, function (visit) {
						return self.selectedVisit.job.site.single_line_address == visit.job.site.single_line_address
					});

					if (angular.isObject(route.employee)) {
						if (route.employee.id === self.selectedVisit.employee.id) {
							existingRoute = true;
							delete self.selectedVisit.saved_route;
							route.visits.push(self.selectedVisit);
						}
					}
				});

				if (!existingRoute) {
					// create new route and add visit to it
					if (!angular.isObject(self.routes)) {
						angular.extend(self, {
							routes: []
						});
					}
					self.routes.push({
						date: self.selectedVisit.visit_date,
						employee_id: self.selectedVisit.employee.id,
						employee: angular.copy(self.selectedVisit.employee),
						visits: [
							angular.copy(self.selectedVisit)
						]
					});

				}

				// copy this route to the visit so we don't have to retrieve it later
				angular.extend(self.selectedVisit, {
					saved_route: {
						routes: angular.copy(self.routes),
						date: self.selectedVisit.visit_date,
						employees: self.employees
					}
				});

				updateVisitFooter(self.selectedVisit);

			}, 50);

		}

		function calculateTravelTime(route) {
			var params = {
				route: route
			};

			VisitPlannerSvc.calculateTravelTime(params).then(function (response) {
				route.total_travel_time = response.data.total_minutes;

				// find our visit and save the route back to this
				angular.forEach(route.visits, function (visit) {
					if (visit.job.site.id === self.quote.site.id) {
						angular.extend(visit, {
							saved_route: {
								routes: angular.copy(route),
								date: route.date,
								employees: self.employees
							}
						});
					}
				});

				// sync back to main visits
				angular.forEach(self.quote.visits, function (visit) {
					if (visit.visit_date === route.date) {
						if (angular.isObject(visit.route)) {
							angular.extend(visit.route, {
								total_work_time: route.total_work_time,
								total_travel_time: route.total_travel_time,
								date: visit.visit_date
							});
						}
						else {
							angular.extend(visit, {
								route: {
									date: visit.visit_date,
									total_travel_time: route.total_travel_time
								}
							});
						}
					}
				});

			});
		}

		function getWorkInArea(visit) {
			if (angular.isDefined(visit.visit_date)) {
				var params = {
					site: visit.job.site.id,
					date: visit.visit_date
				};
				VisitPlannerSvc.workInArea(params)
					.then(function (response) {
						self.recommendations = {
							exist: response.data.visit_collection_day_after.length > 0 || response.data.visit_collection_day_before.length > 0,
							dayAfter: response.data.visit_collection_day_after,
							dayBefore: response.data.visit_collection_day_before
						};
					});
			}
		}

		function submit() {

			angular.forEach(self.quote.visits, function (visit) {
				if (angular.isObject(visit.saved_route)) {
					//delete visit.saved_route;
				}
			});

			var params = {
				quote: self.quote
			};
			return VisitPlannerSvc.save(params).then(function (response) {

				notify({
					message: 'Visits successfully updated'
				});
				if ($state.params.return === 'convert-quote') {
					$state.go('main.trugreen.quote.index.view.convert', {quoteId: $state.params.quoteId});
				}
				else {
					$state.go('main.trugreen.quote.index.view', {quoteId: self.quote.id});
				}
			});
		}

		var self = $scope.TGVPCtrl = {
			loading: true,
			loadingRoute: false,
			intervals: [],
			quote: null,
			summaryView: 'all-visits',
			selectedVisit: null,
			recommendations: {
				exists: false
			},
			methods: {
				init: init,
				addVisit: addVisit,
				cancel: cancel,
				submit: submit,
				dropTreatmentToVisitCallback: dropTreatmentToVisitCallback,
				dropTreatmentFromVisitCallback: dropTreatmentFromVisitCallback,
				updateTreatmentTime: updateTreatmentTime,
				updateVisitFooter: updateVisitFooter,
				dropInserted: dropInserted,
				dragStarted: dragStarted,
				removeVisit: removeVisit,
				updateVisitDates: updateVisitDates,
				unusedTreatmentCount: unusedTreatmentCount,
				setSelectedVisit: setSelectedVisit,
				visitDateUpdated: visitDateUpdated,
				technicianUpdated: technicianUpdated,
				calculateTravelTime: calculateTravelTime,
				copyPlanFromSourceJob: copyPlanFromSourceJob
			}
		}

	});
